<template>
  <ion-card color="light">
    <ion-icon
      v-if="hasUnread"
      :icon="notifications"
      class="unread-bell-icon"
      :style="{ color: branding.color_primary }"
      @click="goToMessages"
    ></ion-icon>
    <ion-card-content>
      <ion-grid :fixed="true">
        <ion-row>
          <ion-col size-md="2" size-xs="12" class="bordered-col">
            <ion-list lines="none">
              <ion-item>
                <ion-label class="ion-text-wrap">
                  <h3>{{ claim.product }}</h3>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-col>
          <ion-col size-md="2" size-xs="6" class="bordered-col">
            <ion-list lines="none">
              <ion-item>
                <ion-label class="ion-text-wrap">
                  <h4 :style="{ color: branding.color_primary }">
                    Product Number
                  </h4>
                  <p>{{ claim.policy_no }}</p>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-col>
          <ion-col size-md="2" size-xs="6" class="bordered-col">
            <ion-list lines="none">
              <ion-item>
                <ion-label>
                  <h4 :style="{ color: branding.color_primary }">Status</h4>
                  <p>{{ claim.claim_status }}</p>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-col>
          <ion-col size-md="2" size-xs="6" class="bordered-col">
            <ion-list lines="none">
              <ion-item>
                <ion-label>
                  <h4 :style="{ color: branding.color_primary }">
                    Request Raised
                  </h4>
                  <p>{{ claim.date_of_loss }}</p>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-col>
          <ion-col size-md="2" size-xs="6" class="bordered-col">
            <ion-list lines="none">
              <ion-item>
                <ion-label>
                  <h4 :style="{ color: branding.color_primary }">
                    Request Number
                  </h4>
                  <p>{{ claim.claim_no }}</p>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-col>
          <ion-col size-md="2" size-xs="6">
            <ion-list lines="none">
              <ion-item>
                <ion-label class="ion-text-wrap">
                  <h4 :style="{ color: branding.color_primary }">
                    Causal Part
                  </h4>
                  <p>{{ claim.claim_causal_part || '—' }}</p>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
</template>

<script setup>
import {
  IonCard,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
} from '@ionic/vue';
import { notifications } from 'ionicons/icons';
import { defineProps, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useBrandingStore } from '../store/branding';
import { useCustomerStore } from '../store/customer';

const props = defineProps({
  claim: {
    type: Object,
    required: true,
  },
});

const router = useRouter();
const brandingStore = useBrandingStore();
const branding = brandingStore.brandCSS;
const customerStore = useCustomerStore();

const hasUnread = computed(() =>
  (customerStore.messagesByClaimId[props.claim.id] || []).some((message) => !message.readAt)
);

function goToMessages() {
  router.push({ name: 'claim-messages', params: { claimId: props.claim.id } });
}
</script>

<style lang="scss" scoped>
h3 {
  font-weight: bold;
}

ion-card {
  position: relative;
  margin: 0 auto;
}

.unread-bell-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  font-size: 22px;
  cursor: pointer;
}

h4 {
  color: #ef7e31;
  font-weight: bold;
}

p {
  color: #252539;
}

ion-item {
  --background: #ffffff;
}

ion-list {
  background: #ffffff;
}

@media (min-width: 769px) {
  .bordered-col {
    border-right: 1px solid #f2f2f2;
  }
}
</style>
